import React from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Top-right pill on the expanded map that collapses it back to the mini
 * strip. Parent owns the state via `onClick` (`minimizeMap` from
 * `useGuestMapDrag`).
 */
export function MapMinimizeButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={(event) => { event.stopPropagation(); onClick(); }}
      data-testid="map-minimize-button"
      style={{
        position: 'absolute',
        top: 16,
        right: 16,
        zIndex: 1000,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        borderRadius: 999,
        border: '1px solid var(--card-border)',
        background: 'var(--surface)',
        padding: '10px 14px',
        cursor: 'pointer',
        boxShadow: 'var(--premium-shadow-nested)',
        fontFamily: "'Inria Serif', serif",
        fontSize: 12.5,
        fontWeight: 700,
        color: 'var(--text)',
      }}
    >
      <ChevronDown size={16} />
      Minimize
    </button>
  );
}
